/**
 * Created by Wang.Chen on 2022/6/15.
 */
 import React from 'react'
 import { Button, Checkbox, Spin, Form, Table, Input, Radio, Select, Calendar, Tabs, DatePicker, InputNumber, TreeSelect, Switch, Col, Row } from 'antd'
 import 'antd/dist/antd.css'
 import '../../common.scss'
 import store from '../../../../redux/store'
 import actionWays from '../../../../redux/actions';
 import { getRecruitment } from '../../../../utils/api/index'
 import moment from "moment";
 import Tap from '../../Tab/index'
 const { RangePicker } = DatePicker;
 const { TextArea } = Input;
 const { TabPane } = Tabs;
 const { Option } = Select;
 // const [form] = Form.useForm();
 
 import { connect } from "react-redux";
 import { withRouter } from "react-router-dom";
 class FormBase extends React.Component {
   forms = React.createRef()
   constructor(props) {
     super(props);
     console.log('props', props)
     this.state = {
       data: '',
       loading: true,
       hasTap: props.hasTap,
       formBase: props.formBase,
       hasSearch: props.hasSearch,
       isFull: props.isFull,
       id: props.id,
       isChange: props.isChange
 
     };
 
   }
   componentWillReceiveProps = async (nextProps) => {
   //   // console.log(nextProps);
   //   // console.log('**********************');
     if (nextProps.isChange !== false) {
       this.forms.current.setFieldsValue({
         'positionName': nextProps.formBase.formList[0] && nextProps.formBase.formList[0].value ? nextProps.formBase.formList[0].value : '',
         'wage': nextProps.formBase.formList[1] && nextProps.formBase.formList[1].value ? nextProps.formBase.formList[1].value : '',
         'status': nextProps.formBase.formList[2] && nextProps.formBase.formList[2].value ? nextProps.formBase.formList[2].value == 0 ? '正常' : '急招' : '',
         'numbers': nextProps.formBase.formList[3] && nextProps.formBase.formList[3].value ? nextProps.formBase.formList[3].value : '',
         'address': nextProps.formBase.formList[4] && nextProps.formBase.formList[4].value ? nextProps.formBase.formList[4].value : '',
         'department': nextProps.formBase.formList[5] && nextProps.formBase.formList[5].value ? nextProps.formBase.formList[5].value : '',
         'positionContext': nextProps.formBase.formList[6] && nextProps.formBase.formList[6].value ? nextProps.formBase.formList[6].value : '',
         'positionRequirements': nextProps.formBase.formList[7] && nextProps.formBase.formList[7].value ? nextProps.formBase.formList[7].value : '',
       })
     } else {
       // const value = await this.forms.current?.getFieldsValue()
       // this.forms.current.setFieldsValue({
       //   'positionName': value.positionName ? value.positionName : '',
       //   'wage': value.wage ? value.wage : '',
       //   'status': value.status ? value.status : '请选择',
       //   'numbers': value.numbers ? value.numbers : '',
       //   'address': value.address ? value.address : '',
       //   'department': value.department ? value.department : '',
       //   'positionContext': value.positionContext ? value.positionContext : '',
       //   'positionRequirements': value.positionRequirements ? value.positionRequirements : '',
       // })
     }
 
   }
   //render前 
   componentDidMount() {
    let opt = {}
    opt.positionName = !! this.state.formBase.formList[0].value ? this.state.formBase.formList[0].value : ''
    opt.recordtime = !!this.state.formBase.formList[1].value ? this.state.formBase.formList[1].value : ''
    opt.numbers = !!this.state.formBase.formList[2].value ? this.state.formBase.formList[2].value : ''
    opt.address = !!this.state.formBase.formList[3].value ? this.state.formBase.formList[3].value : ''
    opt.department = !!this.state.formBase.formList[4].value ? this.state.formBase.formList[4].value : ''
    opt.pageSize = 500
    opt.pageIndex = 0
    this.recruitment(opt)
     // let lists = []
     // formBase.map((i,n)=>{
     //   console.log(i.key)
     //   // lists.push({})
     // })
     // form.setFieldsValue({})
   }
 
   //获取职位列表
   recruitment = async (e) => {
     let res = await getRecruitment(e)
     if (res.code === 0) {
       this.setState({
         data: res.data,
         loading: false
       })
     }
   }
   switchItem = (props) => {
     let lists = props.v
     // console.log('lists', lists)
 
     //判断form类型并返回 未完成全部类型
     switch (lists.type) {
       case 'Select':
         lists.render = <Select value={lists.value} placeholder={lists.value ? lists.value == 0 ? '正常' : '急招' : "请选择"} onChange={(e) => {
           this.state.formBase.formList[props.i].value = e
           this.setState({
             formBase: this.state.formBase
           })
           const actions = actionWays.saveFormData({ ...this.state.formBase })
           store.dispatch(actions)
         }}>
           {
             lists.baseInfo.map((v, i) => {
               return (<Option key={i} value={i}>{v}</Option>)
             })
           }
         </Select>
         return lists.render;
       case 'Checkbox':
         lists.render = <Checkbox.Group>
           <Row>
             {
               lists.baseInfo.map((v, i) => {
                 return (<Col key={i}>
                   <Checkbox value={v}>{v}</Checkbox>
                 </Col>)
               })
             }
           </Row>
         </Checkbox.Group>;
         return lists.render
       case 'Table':
         lists.render = '';
         return lists.render
       case 'Input':
         // console.log(lists.value)
 
         lists.render = <Input hidden={lists.name === 'positionRequirements' || lists.name === 'positionContext' ? true : false} onChange={(e) => {
           this.state.formBase.formList[props.i].value = e.target.value
           this.setState({
             formBase: this.state.formBase
           })
           const actions = actionWays.saveFormData({ ...this.state.formBase })
           store.dispatch(actions)
         }} />;
         return lists.render
       case 'Radio':
         lists.render = '';
         return lists.render
       case 'InputNumber':
         lists.render = <InputNumber defaultValue={lists.value ? lists.value : ''} onChange={(e) => {
           this.state.formBase.formList[props.i].value = e.target.value
           this.setState({
             formBase: this.state.formBase
           })
           const actions = actionWays.saveFormData({ ...this.state.formBase })
           console.log('actions', actions)
           store.dispatch(actions)
         }}>
         </InputNumber>;
         return lists.render
       case 'Calendar':
         lists.render = '';
         return lists.render
       case 'Tabs':
         lists.render = '';
         return lists.render
       case 'DatePicker':
         lists.render = <DatePicker onChange={(e) => {
           this.state.formBase.formList[props.i].value = moment(e).format('YYYY-MM-DD') != 'Invalid date' ? moment(e).format('YYYY-MM-DD') : ''
           this.setState({
             formBase: this.state.formBase
           })
           const actions = actionWays.saveFormData({ ...this.state.formBase })
           store.dispatch(actions)
         }} />;
         return lists.render
       case 'TreeSelect':
         lists.render = '';
         return lists.render
       case 'Switch':
         lists.render = '';
         return lists.render
       default:
         lists.render = '';
     }
   }
   render() {
     const { data, loading, hasTap, formBase, hasSearch, isFull, id } = this.state
     return (
       <div id={id}>
         <div>
           {isFull ? <div className="col-lg-1"></div> : null}
           <div className="col-lg-1"></div>
           <div className={isFull ? "col-lg-12" : "col-lg-10"}>
             <Row className='choose_new'>
               <Form ref={this.forms} de name="horizontal_login" layout="inline" >
                 {
                   formBase.formList.map((v, i) => {
                     return (<Form.Item key={i} hidden={v.name === 'positionRequirements' || v.name === 'positionContext' ? true : false} style={{ marginBottom: '5px', marginTop: '5px' }} name={v.name} label={v.label} rules={v.rules}>
                       {this.switchItem({ v, i })}
                     </Form.Item>)
                   })
                 }
                 <Form.Item shouldUpdate >
                   {hasSearch ? <Button
                     style={{ background: '#0093D8', color: '#fff', marginTop: '5px' }}
                     htmlType="submit"
                     onClick={() => {
                       this.setState({
                         loading: true
                       })
                       let opt = {}
                       opt.positionName = !!formBase.formList[0].value ? formBase.formList[0].value : ''
                       opt.recordtime = !!formBase.formList[1].value ? formBase.formList[1].value : ''
                       opt.numbers = !!formBase.formList[2].value ? formBase.formList[2].value : ''
                       opt.address = !!formBase.formList[3].value ? formBase.formList[3].value : ''
                       opt.department = !!formBase.formList[4].value ? formBase.formList[4].value : ''
                       opt.pageSize = 500
                       opt.pageIndex = 0
 
                       this.recruitment(opt)
                     }}
                   >
                     搜索
                   </Button> : null}
 
                 </Form.Item>
               </Form>
             </Row>
 
           </div>
           {isFull ? <div className="col-lg-1"></div> : null}
         </div>
         <div>
           {loading && hasTap ? <Spin /> : hasTap ? <Tap msg={data} /> : null}
 
         </div>
       </div>
     )
   }
 
 
 
 
 
 }
 
 export default (withRouter(FormBase))
 